import './_styles.scss';
import React, { StatelessComponent } from 'react';
import {
    PLAY_LIST_CONTAINER,
    PLAY_LIST_HEADER,
    PLAY_LIST_BODY,
    PLAY_LIST_ITEM,
    BUTTON_NO_TEXT_TRANSFORMATION
} from '../utils/constants';
import { Button } from '../Button';

export interface IRadioListItem {
    phonogramId: number;
    title: string;
    artist: string;
    station: string;
    timeRemaining: string;
    url: string;
    songIndex?: number;
    type?: string;
}

export interface IRadioListProps {
    headerText: string[];
    items: IRadioListItem[];
    onClick?: (item: IRadioListItem) => void;
    onBlur?: (item: IRadioListItem) => void;
    onFocus?: (item: IRadioListItem) => void;
}

export const RadioList: StatelessComponent<IRadioListProps> = props => {
    const { headerText, items, onBlur, onClick, onFocus } = props;

    const getColumn = (index: number, columnText: string): React.ReactNode => {
        if (index === 0) {
            return (
                <span>
                    <i className="fa fa-play nonDisplay" aria-hidden="true" />
                    {columnText}
                </span>
            );
        }

        return <span>{columnText}</span>;
    };

    const getList = (songInfo: string[], id: string): React.ReactChild => {
        return (
            <div className="song" id={`song-${id}`}>
                {songInfo.map((columnText, index) => {
                    return <div className="column">{getColumn(index, columnText)}</div>;
                })}
            </div>
        );
    };

    const onClickButton = (song: IRadioListItem): void => {
        if (typeof onClick === 'function') {
            onClick(song);
        }
    };

    const onBlurButton = (song: IRadioListItem): void => {
        if (typeof onBlur === 'function') {
            onBlur(song);
        }
    };

    const onFocusButton = (song: IRadioListItem): void => {
        if (typeof onFocus === 'function') {
            onFocus(song);
        }
    };

    const getElementID = (phonogramId: number, songIndex?: number): string => {
        let elementId = '';

        if (phonogramId) {
            elementId = phonogramId.toString();
        } else {
            elementId = songIndex ? songIndex.toString() : '';
        }

        return elementId;
    };

    const getHeader = (): React.ReactNode => {
        return (
            <div className={PLAY_LIST_HEADER}>
                {headerText.map(head => {
                    return <div className="column">{head}</div>;
                })}
            </div>
        );
    };

    const getSongs = (songs: IRadioListItem[]): React.ReactElement[] => {
        return songs.map((song, songIndex) => {
            const radioListSong: IRadioListItem = {
                phonogramId: song.phonogramId,
                title: song.title,
                artist: song.artist,
                station: song.station,
                timeRemaining: song.timeRemaining,
                url: song.url,
                songIndex,
                type: 'radio'
            };
            return (
                <Button
                    type="button"
                    variant="info"
                    className={`${PLAY_LIST_ITEM} focusable ${BUTTON_NO_TEXT_TRANSFORMATION}`}
                    onClick={(): void => {
                        onClickButton(radioListSong);
                    }}
                    onBlur={(): void => {
                        onBlurButton(radioListSong);
                    }}
                    onFocus={(): void => {
                        onFocusButton(radioListSong);
                    }}
                >
                    {getList(
                        [
                            `${songIndex + 1}. ${song.artist}`,
                            song.title,
                            song.timeRemaining,
                            song.station
                        ],
                        getElementID(song.phonogramId, songIndex)
                    )}
                </Button>
            );
        });
    };

    return (
        <div className={`${PLAY_LIST_CONTAINER} radioSection`}>
            <div className={PLAY_LIST_BODY}>
                {getHeader()}
                {getSongs(items)}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/RadioList/index.tsx